import { render, staticRenderFns } from "./appVersion.vue?vue&type=template&id=d5ad7eca&scoped=true"
import script from "./appVersion.vue?vue&type=script&lang=js"
export * from "./appVersion.vue?vue&type=script&lang=js"
import style0 from "./appVersion.vue?vue&type=style&index=0&id=d5ad7eca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ad7eca",
  null
  
)

export default component.exports